import api, { setAuthToken } from './resourceService';

function loadGoogleScript() {
  if (window.google?.accounts?.id) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const existingScript = window.document.querySelector('script[data-google-identity]');

    if (existingScript) {
      existingScript.addEventListener('load', resolve, { once: true });
      existingScript.addEventListener('error', reject, { once: true });
      return;
    }

    const script = window.document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.dataset.googleIdentity = 'true';
    script.addEventListener('load', resolve, { once: true });
    script.addEventListener('error', reject, { once: true });
    window.document.head.appendChild(script);
  });
}

export async function getAuthConfig() {
  const response = await api.get('/auth/config');
  return response.data;
}

export async function getCurrentUser() {
  try {
    const response = await api.get('/auth/me');
    setAuthToken('');
    return response.data.user || null;
  } catch (error) {
    setAuthToken('');
    return null;
  }
}

export async function signInWithGoogleCredential(credential) {
  const response = await api.post('/auth/google', { credential });
  setAuthToken('');
  return response.data.user;
}

export async function signOut() {
  try {
    await api.post('/auth/logout');
  } catch (error) {
    // Clear local auth state even if the server is temporarily unreachable.
  }

  setAuthToken('');

  if (window.google?.accounts?.id) {
    window.google.accounts.id.disableAutoSelect();
  }
}

export async function deleteAccount() {
  const response = await api.delete('/auth/account');
  setAuthToken('');

  if (window.google?.accounts?.id) {
    window.google.accounts.id.disableAutoSelect();
  }

  return response.data;
}

export async function renderGoogleButton(element, clientId, callback) {
  if (!element || !clientId) {
    return;
  }

  await loadGoogleScript();
  element.innerHTML = '';
  window.google.accounts.id.initialize({
    client_id: clientId,
    callback,
  });
  window.google.accounts.id.renderButton(element, {
    theme: 'outline',
    size: 'medium',
    type: 'standard',
    shape: 'rectangular',
  });
}
